import {
  OBTENER_EMPRESAS_SUCCESS,
  OBTENER_EMPRESAS_ERROR,
  OBTENER_MOTIVOS_SUCCESS,
  OBTENER_MOTIVOS_ERROR,
  OBTENER_SUBMOTIVOS_SUCCESS,
  OBTENER_SUBMOTIVOS_ERROR,
  OBTENER_ESTADOS_SUCCESS,
  OBTENER_ESTADOS_ERROR,
  CONSULTA_PAGOS_Y_FACTURAS_SUCCESS,
  CONSULTA_PAGOS_Y_FACTURAS_ERROR,
  NUEVA_CONSULTA_SUCCESS,
  NUEVA_CONSULTA_ERROR,
  OBTENER_TRAMITES_ANTERIORES_SUCCESS,
  OBTENER_TRAMITES_ANTERIORES_ERROR,
  RESET_TRAMITES_ANTERIORES,
  AGREGAR_COMENTARIO_SUCCESS,
  AGREGAR_COMENTARIO_ERROR,
  AGREGAR_ARCHIVO_SUCCESS,
  AGREGAR_ARCHIVO_ERROR,
  LOADING_FACTURAS_END,
  LOADING_FACTURAS,
  SEARCH_CONSULTORIOS,
  FIRST_CONSULTORIOS,
  OBTENER_ARCHIVOS_ADJUNTOS_SUCCESS,
  OBTENER_ARCHIVOS_ADJUNTOS_ERROR,
  RESET_SUBMOTIVOS,
} from '../constants/index';

function filterSearchConsultorios(state, data) {
  return { ...state, consultorios: data };
}

const initialState = {
  usuarios: [],
  loading: false,
  usuarioModificado: {},
  consultorios: [],
  firstConsultorios: [],
  archivosAdjuntos: {},
};

export default function consultaDePagosYFacturas(state = initialState, action) {
  const newState = { ...state };
  switch (action.type) {
    // EMPRESAS
    case OBTENER_EMPRESAS_SUCCESS:
      newState.empresas = action.data;
      return newState;
    case OBTENER_EMPRESAS_ERROR:
      newState.empresas = 'Error';
      return newState;
    // MOTIVOS
    case OBTENER_MOTIVOS_SUCCESS:
      newState.motivos = action.data;
      return newState;
    case OBTENER_MOTIVOS_ERROR:
      newState.motivos = 'Error';
      newState.subMotivos = 'Error';
      return newState;
    // SUBMOTIVOS
    case OBTENER_SUBMOTIVOS_SUCCESS:
      newState.subMotivos = action.data;
      return newState;
    case OBTENER_SUBMOTIVOS_ERROR:
      newState.subMotivos = 'Error';
      return newState;
    case RESET_SUBMOTIVOS:
      newState.subMotivos = [];
      return newState;
    // ESTADOS
    case OBTENER_ESTADOS_SUCCESS:
      newState.estados = action.data;
      return newState;
    case OBTENER_ESTADOS_ERROR:
      newState.estados = 'Error';
      return newState;
    // CONSULTA
    case CONSULTA_PAGOS_Y_FACTURAS_SUCCESS:
      newState.consulta = action.data;
      return newState;
    case CONSULTA_PAGOS_Y_FACTURAS_ERROR:
      newState.consulta = [];
      return newState;
    // TRAMITES ANTERIORES
    case OBTENER_TRAMITES_ANTERIORES_SUCCESS:
      newState.tramitesAnteriores = action.data;
      return newState;
    case OBTENER_TRAMITES_ANTERIORES_ERROR:
      newState.tramitesAnteriores = 'Error';
      return newState;
    case RESET_TRAMITES_ANTERIORES:
      newState.tramitesAnteriores = [];
      return newState;
    // NUEVA CONSULTA
    case NUEVA_CONSULTA_SUCCESS:
      newState.nuevaConsulta = action.data;
      return newState;
    case NUEVA_CONSULTA_ERROR:
      newState.nuevaConsulta = 'Error';
      return newState;
    case LOADING_FACTURAS_END:
      newState.loading = false;
      return newState;
    case LOADING_FACTURAS:
      newState.loading = true;
      return newState;
    case FIRST_CONSULTORIOS:
      return { ...state, firstConsultorios: action.json };
    case SEARCH_CONSULTORIOS:
      return filterSearchConsultorios(newState, action.json);
    case OBTENER_ARCHIVOS_ADJUNTOS_SUCCESS: {
      const items = action?.data?.imagenesArchivo?.items ?? [];
      const nroTramite = action?.data?.pk?.nroTramite;
      if (Array.isArray(items)) {
        newState.archivosAdjuntos[nroTramite] = items;
      }
      return newState;
    }

    case OBTENER_ARCHIVOS_ADJUNTOS_ERROR:
      newState.archivosAdjuntos[action?.data?.pk?.nroTramite] = [];
      return newState;

    default:
      return newState;
  }
}
